export default "__VITE_ASSET__CQugEZ8X__"